module.exports = __webpack_public_path__ + "static/media/copinho.32b56430.jpg";